/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Allocation_Accepted_Title1Inputs */

const en_coinvestments_allocation_accepted_title1 = /** @type {(inputs: Coinvestments_Allocation_Accepted_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation accepted`)
};

/**
* | output |
* | --- |
* | "Allocation accepted" |
*
* @param {Coinvestments_Allocation_Accepted_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_allocation_accepted_title1 = /** @type {((inputs?: Coinvestments_Allocation_Accepted_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Allocation_Accepted_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_allocation_accepted_title1(inputs)
});
export { coinvestments_allocation_accepted_title1 as "coInvestments_allocation_accepted_title" }